import Footer from '../Components/Footer'
import { useTranslation } from 'react-i18next'
import { Avatar, Box, Container, Divider, List, ListItem, ListItemAvatar, ListItemText } from '@mui/material';
import { Variants, motion } from "framer-motion"
import DrawerAppBar from '../Components/DrawerAppBar';
import Menus from '../Components/Menus';
import TitrePage from '../Components/TitrePage';
import { Home } from '@mui/icons-material';
import React from 'react';
import EllipseGauche from "../Fichiers/Ellipse 200.svg"
import EllipseDroite from "../Fichiers/Ellipse 201.svg"
import illution_4 from "../Fichiers/illution_4.svg";

interface Props { }

function FondsPropres(props: Props) {
        const { t } = useTranslation();
        

    const scroll: Variants = {
        offscreen: {
            x: 80,
            opacity: .3
        },
        onscreen: {
            x: 0,
            opacity: 1,
            transition: {
                bounce: 0.6,
                duration: 1
            }
        }
    };


    return (
        <div style={{ backgroundColor: "inherit" }}>
            <DrawerAppBar /><br />
            <Menus />
            <TitrePage titre={t("PRODUITS_SERVICES.titre13")} lien="PRODUITS_SERVICES.titre13" />
            <br /><br /><br /><br /><br /><br /><br /><br />



            <Box display={"flex"} lineHeight={1.6} textAlign={"justify"}>
                <Box gap={5} display={{ sx: "none", sm: "contents" }}>
                    <img style={{ width: "5%" }} draggable={false} src={EllipseGauche} alt="" />
                </Box>

                <Container maxWidth='lg'>
                    <Box id="PartsSociales" display={{ xs: 'block', sm: 'flex' }} >

                        <Box textAlign={"justify"}>
                            <motion.div
                                initial="offscreen"
                                whileInView="onscreen"
                                viewport={{ once: true, amount: 0.8 }}
                                variants={scroll}
                                className='produitsEtServices'
                            >
                                <br />
                                <img width={"80%"} src={illution_4} alt="" /><br /><br />

                            </motion.div>
                            <label style={{ fontSize: 'large', fontWeight: "bold", color: "#40805C" }} htmlFor="">{t("FONDS_PROPRES.PARTS_SOCIALES.texte.partie1")}</label>
                            <br /><br />
                            <label className='textgray' htmlFor="">
                                {t("FONDS_PROPRES.PARTS_SOCIALES.texte.partie2")}
                            </label>
                            <br /><br />
                            <label className='textgray' htmlFor="">
                                {t("FONDS_PROPRES.PARTS_SOCIALES.texte.partie3")}
                            </label>
                            <br /><br />
                            <label className='textgray' style={{ fontWeight: "bold" }} htmlFor="">
                                {t("FONDS_PROPRES.PARTS_SOCIALES.texte.partie4")}
                            </label>
                            <br /><br />

                            <List>
                                {(t("FONDS_PROPRES.PARTS_SOCIALES.texte.partie5").split("|")).map((t) => (
                                    <>
                                        <ListItem alignItems="flex-start">
                                            <ListItemAvatar>
                                                <Avatar alt="Remy Sharp"><Home /></Avatar>
                                            </ListItemAvatar>
                                            <ListItemText
                                                primary={t}
                                                secondary={
                                                    <React.Fragment>
                                                        {""}
                                                    </React.Fragment>
                                                }
                                            />
                                        </ListItem>
                                        <Divider variant="inset" component="li" />
                                    </>
                                ))}
                            </List>


                        </Box>
                        <Box width={"50%"} />
                        <motion.div
                            initial="offscreen"
                            whileInView="onscreen"
                            viewport={{ once: true, amount: 0.8 }}
                            variants={scroll}
                            className='produitsEtServices'
                        >
                            <Box>
                                <motion.div
                                    whileHover={{ scale: 1, rotate: 1 }}
                                    whileTap={{
                                        scale: 1,
                                        rotate: -1,
                                    }}
                                >
                                    <center><br /><br />
                                        <Box>
                                            <div><img style={{ borderRadius: "10%" }} width={250} height={250} src={require('../Database/Files/ProduitsEtServices/FondsPropres/partSocial.png')} alt="" /></div>
                                        </Box>
                                    </center>
                                </motion.div>
                            </Box>
                        </motion.div>
                    </Box>
                    <br />
                    <Box id="FondDeSolidarite" display={{ xs: 'block', sm: 'flex' }} >

                        <Box textAlign={"justify"}>
                            <motion.div
                                initial="offscreen"
                                whileInView="onscreen"
                                viewport={{ once: true, amount: 0.8 }}
                                variants={scroll}
                                className='produitsEtServices'
                            >
                                <br />
                                <img width={"80%"} src={illution_4} alt="" /><br /><br />

                            </motion.div>
                            <label style={{ fontSize: 'large', fontWeight: "bold", color: "#40805C" }} htmlFor="">{t("FONDS_PROPRES.FOND_DE_SOLIDARITE.titre")}</label>
                            <br /><br />
                            <label className='textgray' htmlFor="">
                                {t("FONDS_PROPRES.FOND_DE_SOLIDARITE.texte.partie2")}
                            </label>

                        </Box>
                        <Box width={"50%"} />
                        <motion.div
                            initial="offscreen"
                            whileInView="onscreen"
                            viewport={{ once: true, amount: 0.8 }}
                            variants={scroll}
                            className='produitsEtServices'
                        >
                            <Box>
                                <motion.div
                                    whileHover={{ scale: 1, rotate: 1 }}
                                    whileTap={{
                                        scale: 1,
                                        rotate: -1,
                                    }}
                                >
                                    <center><br /><br />
                                        <Box>
                                            <div><img style={{ borderRadius: "10%" }} width={250} height={250} src={require('../Database/Files/ProduitsEtServices/FondsPropres/fontsDeSolidarite.png')} alt="" /></div>
                                        </Box>
                                    </center>
                                </motion.div>
                            </Box>
                        </motion.div>
                    </Box>
                    <img width={"50%"} src={illution_4} alt="" />
                    <br /><br />
                </Container>
                <Box gap={5} display={{ sx: "none", sm: "contents" }}>
                    <img style={{ width: "5%", marginLeft: "2%" }} draggable={false} src={EllipseDroite} alt="" />
                </Box>
            </Box>
            <br /><br />


            <br /><br /><br />

            <Footer />
        </div>
    )
}
export default FondsPropres